import { useEffect } from 'react'
import { Outlet } from '@tanstack/react-router'
import { AppShell } from '@app/shell/AppShell'
import { useSession } from '@shared/lib/auth/session-store'

function buildLoginUrl() {
  const redirect = `${window.location.pathname}${window.location.search}`
  return `/login?redirect=${encodeURIComponent(redirect)}`
}

function useRequiredSessionToken() {
  const token = useSession((state) => state.token)

  useEffect(() => {
    if (!token) {
      window.location.replace(buildLoginUrl())
    }
  }, [token])

  return token
}

export function AuthGate() {
  const token = useRequiredSessionToken()
  if (!token) return null
  return <AppShell />
}

export function SessionOutlet() {
  const token = useRequiredSessionToken()
  if (!token) return null
  return <Outlet />
}
